// Which IRS Jovem year a calendar year is, and how much is exempt (art. 12.º-B CIRS, as of 2025).
//
// - Up to 10 years of employment/self-employment income, counted from the first year that income was earned as a
//   taxpayer in their own right (not as a dependant in their parents' return).
// - Years with no such income, years filed as a dependant, and years exempt from filing don't count.
// - Age is checked on 31 December of each year: 35 or younger.
// - 100% the 1st year, 75% the 2nd–4th, 50% the 5th–7th, 25% the 8th–10th. Exempt amount capped at 55 × IAS.
//
// settings: { enabled, firstYear, skipYears: [year, ...] }

import { ageOn } from '../calendar.js';

export const DEFAULT_PERCENTAGES = [100, 75, 75, 75, 50, 50, 50, 25, 25, 25];

export function jovemYear(settings, birthDate, year, percentages = DEFAULT_PERCENTAGES, maxAge = 35) {
  const s = settings || {};
  const base = { year, index: null, pct: 0, eligible: false, age: birthDate ? ageOn(birthDate, `${year}-12-31`) : null };
  if (!s.enabled) return { ...base, reason: 'IRS Jovem is turned off' };
  const first = Number(s.firstYear);
  if (!Number.isInteger(first)) return { ...base, reason: 'Set the first year of income' };
  if (year < first) return { ...base, reason: `Starts in ${first}` };
  const skip = new Set((s.skipYears || []).map(Number));
  if (skip.has(year)) return { ...base, reason: "Doesn't count (filed as a dependant or no work income)" };
  let index = 1;
  for (let y = first; y < year; y++) if (!skip.has(y)) index++;
  const withIndex = { ...base, index };
  if (index > percentages.length) return { ...withIndex, reason: `Past the ${percentages.length} years` };
  if (base.age !== null && base.age > maxAge) return { ...withIndex, reason: `Over ${maxAge} on 31 December` };
  return { ...withIndex, pct: percentages[index - 1], eligible: true, reason: null, ageUnknown: base.age === null };
}

// The whole schedule from the first year until it ends
export function jovemSchedule(settings, birthDate, percentages = DEFAULT_PERCENTAGES, maxAge = 35) {
  const s = settings || {};
  const first = Number(s.firstYear);
  if (!s.enabled || !Number.isInteger(first)) return [];
  const out = [];
  for (let y = first; y < first + 40 && out.filter((x) => x.index).length < percentages.length + 1; y++) {
    const info = jovemYear(s, birthDate, y, percentages, maxAge);
    out.push(info);
    if (info.index && info.index > percentages.length) break;
    if (info.age !== null && info.age > maxAge) break;
  }
  return out;
}
